import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import isNumber from 'lodash/isNumber';

import Divider from '#web-components/components/Divider';
import Link from '#web-components/components/Link';
import Typography from '#web-components/components/Typography';
import UpRightArrowIcon from '#web-components/components/Icons/UpRightArrowIcon';

import menuPanelStyles from './MenuPanel.styles';

export interface Props {
  title: string;
  linkComponent: React.ElementType;
  titleLink?: string;
  countDescription?: string;
  count?: number;
  hasError?: boolean,
  unknownErrorText?: string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  'data-xpath'?: string;
}

const useStyles = makeStyles(menuPanelStyles, { name: 'MenuPanel' });

export default function MenuPanel({
  count,
  title,
  titleLink,
  countDescription,
  onClick,
  hasError,
  linkComponent,
  unknownErrorText,
  'data-xpath': dataXpath,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root} data-xpath={dataXpath}>
      <Divider />
      <Typography variant="h3" className={classes.title} component="h2">
        {
          titleLink && (
            <Link to={titleLink} className={classes.link} component={linkComponent}>
              <UpRightArrowIcon className={classes.linkIcon} />
              {title}
            </Link>
          )
        }
        {
          onClick && (
            <button type="button" className={clsx(classes.link, classes.buttonLink)} onClick={onClick}>
              <UpRightArrowIcon className={classes.linkIcon} />
              {title}
            </button>
          )
        }
        {
          !titleLink && !onClick && title
        }
      </Typography>
      <Typography variant="bodyText" className={classes.description}>
        { countDescription }
      </Typography>
      {hasError ? <Typography halfOpacity variant="h3" component="h3">{unknownErrorText}</Typography> : (
        isNumber(count) && (
          <Typography variant="h1" component="h3">
            { count }
          </Typography>
        )
      )}
    </div>
  );
}
